import Vue from "vue";
import Vuex from "vuex";
import { StudioModule } from '@/store/modules/studio/index';
import { PostsModule } from '@/store/modules/posts/index';
import { MuseumModule } from '@/store/modules/museum/index';
import { ArtistViewModule } from '@/store/modules/artistView/index';
import { CVModule } from '@/store/modules/CV/index';
import { PostModule } from '@/store/modules/post/index';
import { HomeModule } from '@/store/modules/home/index';
import { BookModule } from '@/store/modules/book/index';
import { CircularPianoModule } from '@/store/modules/circular-piano/index';
import { StepSequencerModule } from '@/store/modules/step-sequencer/index';
import { ColorConversionModule } from '@/store/modules/color-conversion/index';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    previousPage: 'Home',
    currentPage: 'Home',
  },
  mutations: {
    setPreviousPage(state, value: string) {
      state.previousPage = value;
    },
    setCurrentPage(state, value: string) {
      state.currentPage = value;
    },
  },
  actions: {},
  modules: {
    StudioModule,
    PostsModule,
    MuseumModule,
    ArtistViewModule,
    CVModule,
    PostModule,
    HomeModule,
    BookModule,
    CircularPianoModule,
    StepSequencerModule,
    ColorConversionModule,
  }
});
